<script>
import GoogleMap from '@/components/googleMap'
import { PlannRoute } from '@/utils/planningRoute'

export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    info () {
      PlannRoute(this.stayPoints, this.mapIds).then(sum => {
        sum.forEach(s => {

        })
      })
    }
  },
  props: {
    // 地图中心点
    centerPoints: Object,
    // 路径数组
    stayPoints: Array,
    // 路径详情数组
    routerInfo: Array,
    // 地图ID
    mapIds: String
  },
  components: {
    GoogleMap
  }
}
</script>

<template>
  <div class="col-md-12 column">
    <div class="modal fade" id="modal-container-routerDetails" role="dialog" data-backdrop="static" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" style="height:100%">
          <!-- 标题 -->
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/X.png"/></button>
            <h3 class="modal-title" id="myModalLabel">ルート确认</h3>
          </div>
          <!-- 主体 -->
          <div class="bodyContext">

            <div class="bodyContext-left slider" style="flex:2">
              <div class='bodyContext-left-children' v-for='(item, i) in routerInfo' :key='i' @click="detailed(item)">
                <!-- 圆圈 -->
                <div class='radioClass'>
                  <!-- 圆圈里面的标记 -->
                  <div class='tagClass'>
                      {{ item.font }}
                  </div>
                </div>
                <!-- 竖线 -->
                <!-- 第一个竖线 -->
                <template v-if='i === 0'>
                    <div class='lineClassEnd'></div>
                </template>
                <!-- 正常常规竖线 -->
                <template v-if='i && i !== 0 && i !== routerInfo.length -1'>
                    <div class='lineClass'></div>
                </template>
                <!-- 最后一个竖线 -->
                <template v-if='i === routerInfo.length -1'>
                    <div class='lineClassFirst'></div>
                </template>

                <div class='bodyContext-left-children-body'>
                    <div class='front'>
                        <p>{{ item.name }}</p>
                    </div>
                </div>
              </div>
            </div>

            <div class="bodyContext-right" style="flex:3">
              <google-map ref='gMapDetails' :center-point='centerPoints' :map-id='mapIds'></google-map>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .bodyContext {
    // border: 1px solid red;
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: row;
    padding: 0 25px;
    .bodyContext-left {
        overflow-y: auto;
        padding-right: 5px;
        &-children {
            background-color: #efefef;
            height: 80px;
            border-bottom: 1px solid #b9b9b8;
            position: relative;
            // 蓝色图标
            .radioClass {
                width: 40px;
                height: 40px;
                position: absolute;
                background-color: #48a3be;
                margin: 20px 0 0 15px;
                border-radius: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                // 覆盖权重
                z-index: 2;
                .tagClass {
                    color: white;
                    font-size: 1.5em;
                    font-weight: 100; // 字体粗度
                }
            }
            // 正常竖线
            .lineClass {
                position: absolute;
                left: 33px;
                width: 4px;
                height: 80px;
                background-color: #48a3be;
            }
            // 图标第一个竖线
            .lineClassFirst {
                position: absolute;
                left: 33px;
                width: 4px;
                height: 40px;
                background-color: #48a3be;
            }
            // 图标末尾竖线
            .lineClassEnd {
                position: absolute;
                left: 33px;
                width: 4px;
                height: 40px;
                top: 40px;
                background-color: #48a3be;
            }
            &-body {
                // border: 1px solid red;
                height: 100%;
                padding-left: 70px;
                display: flex;
                flex-direction: column;
                &:active {
                    background-color: #b2b2b2;
                }
                .front {
                    // border: 1px solid blue;
                    flex: 1;
                    position: relative;
                    & > p {
                        position: absolute;
                        color: black;
                        font-size: 1.5em;
                        font-weight: 600; // 字体粗度
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
            }
        }
    }
    .bodyContext-right {
      padding-left: 5px;
      #routerDetails {
        width: 100%;
        height: 100%;
      }
    }
  }
  .modal-dialog{
    width: 70%;
    height: 80%;
    margin-top: 4%;
  }
  .modal-header{
    border-bottom: 0px;
  }
  .modal-body{
    padding: 0px 40px;
  }
  .close{
    opacity: 1;
  }
  // 滚动条样式
.slider::-webkit-scrollbar {
    width: 5px;
    height: 0px;
}
/* 滚动条中小方块样式 */
.slider::-webkit-scrollbar-thumb {
    border-radius: 10px;
    /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
    background: #000;
}
/* 滑动轨道样式 */
.slider::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
    border-radius: 10px;
    background: #b3b3b3;
}
</style>



// WEBPACK FOOTER //
// src/components/RouterDetails.vue